import { Component, Input, OnChanges } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-firmware",
	templateUrl: "./manage-firmware.component.html",
	styleUrls: ["./manage-firmware.component.scss"]
})
export class ManageFirmwareComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	public assetFirmwareInfo: APIResults.AssetFirmwareInfo;

	public selectFwControl: boolean;
	public selectFwWebpage: boolean;
	public selectFwRegime: boolean;
	public selectFwState: boolean;
	public selectDescribe: boolean;
	public selectIdent: boolean;

	public enableControl = true;
	public enableRegime = true;
	public enableDescribe = true;
	public enableIdent = true;

	constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		await this.RefreshData();
	}

	async RefreshData(): Promise<void> {
		this.assetFirmwareInfo = await this.api.GetAssetFirmwareInfo(this.asset.asset_id);
	}

	async CancelCommand() {
		await this.api.CancelCommand(this.asset.asset_id);
		await this.RefreshData();
	}

	async CreateCommand() {
		if (this.selectIdent && !this.asset.asset_serial_number) {
			throw new Error("The asset serial number must be set before the 'Ident' command can be sent.");
		}
		await this.api.CreateCommand(this.asset.asset_id, {
			control: this.selectFwControl ? this.assetFirmwareInfo.availableControl : undefined,
			webpage: this.selectFwWebpage ? this.assetFirmwareInfo.availableWebpage : undefined,
			regime: this.selectFwRegime ? this.assetFirmwareInfo.availableRegime : undefined,
			state: this.selectFwState ? this.assetFirmwareInfo.availableState : undefined,
			describe: this.selectDescribe,
			ident: this.selectIdent,
		});
		await this.RefreshData();
	}

	checkControl() {
		if (this.selectFwControl || this.selectFwWebpage) {
			this.selectFwRegime = false;
			this.selectFwState = false;
			this.selectDescribe = false;
			this.selectIdent = false;

			this.enableControl = true;
			this.enableRegime = false;
			this.enableDescribe = false;
			this.enableIdent = false;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}

	checkRegime() {
		if (this.selectFwRegime || this.selectFwState) {
			this.selectFwControl = false;
			this.selectFwWebpage = false;
			this.selectDescribe = false;
			this.selectIdent = false;

			this.enableControl = false;
			this.enableRegime = true;
			this.enableDescribe = false;
			this.enableIdent = false;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}

	checkDescribe() {
		if (this.selectDescribe) {
			this.selectFwControl = false;
			this.selectFwWebpage = false;
			this.selectFwRegime = false;
			this.selectFwState = false;
			this.selectIdent = false;

			this.enableControl = false;
			this.enableRegime = false;
			this.enableDescribe = true;
			this.enableIdent = false;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}

	checkIdent() {
		if (this.selectIdent) {
			this.selectFwControl = false;
			this.selectFwWebpage = false;
			this.selectFwRegime = false;
			this.selectFwState = false;
			this.selectDescribe = false;

			this.enableControl = false;
			this.enableRegime = false;
			this.enableDescribe = false;
			this.enableIdent = true;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}
}

